import { useLocation } from "react-router-dom";
import { en, es, type Translations } from "./translations";

export type Locale = "en" | "es";

export function pathLocale(pathname: string): Locale {
  return pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";
}

/** Strip the /es prefix from a path; returns "/" for the bare /es root. */
export function stripLocalePrefix(pathname: string): string {
  if (pathname === "/es") return "/";
  if (pathname.startsWith("/es/")) return pathname.slice(3);
  return pathname;
}

/** Add the /es prefix to a path. */
export function withSpanishPrefix(pathname: string): string {
  if (pathname === "/") return "/es";
  return "/es" + pathname;
}

/** Returns the path that swaps the current locale to the other. */
export function pathInOtherLocale(pathname: string): string {
  if (pathLocale(pathname) === "es") return stripLocalePrefix(pathname);
  return withSpanishPrefix(pathname);
}

export function useLocale(): Locale {
  return pathLocale(useLocation().pathname);
}

export function useT(): Translations {
  return useLocale() === "es" ? es : en;
}

/**
 * Build a path that lives in the current locale.
 * Use for in-app <Link> targets so we stay in the same language.
 *   const localePath = useLocalePath();
 *   <Link to={localePath("/insights/foo")} />
 */
export function useLocalePath(): (path: string) => string {
  const locale = useLocale();
  return (path: string) => {
    const clean = path.startsWith("/") ? path : `/${path}`;
    return locale === "es" ? withSpanishPrefix(clean) : clean;
  };
}
